import { FORM_MODES } from '../constants/formModeConstants';

export const getInitialBankAccountFormMode = ({
  accounts = {},
  requiresCnpj = false,
} = {}) => {
  if (requiresCnpj) return FORM_MODES.CNPJ;
  if (accounts.CNPJ) return FORM_MODES.CNPJ;
  if (accounts.CPF) return FORM_MODES.CPF;
  return FORM_MODES.CNPJ;
};
